import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "card mb-5 mb-xl-8" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = {
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card-body row" }
const _hoisted_12 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_13 = {
  key: 0,
  class: "fa-solid fa-triangle-exclamation fa-fade",
  style: {"color":"red","font-size":"48px"}
}
const _hoisted_14 = {
  class: "px-5",
  style: {"border-radius":"10px","box-shadow":"rgba(0, 0, 0, 0.24) 0px 3px 8px"}
}

import { ref, onMounted, inject } from "vue";
import RebateService from "../services/RebateService";
import SalesRebateSchemaCard from "../components/SalesRebateSchemaCard.vue";
import AddSchama from "../components/AddSalesRebateSchema.vue";
import { salesTypeOptions } from "@/core/types/SalesTypes";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateSchema',
  setup(__props) {

const isLoading = ref(true);
const AddSchamaRef = ref<any>(null);
const data = ref({} as any);
const originalActiveData = ref({} as any);
const hasErrorSetting = ref(false);
const tab = ref({
  active: 0,
  pending: -1,
});

const currentTab = ref(tab.value.active);
const currentSalesType = ref(-1);

const criteria = ref({
  page: 1,
  size: 999,
  salesAccountUid: "",
  rebateAccountUid: "",
  Status: 0,
  sortField: "SalesAccountId",
});

const reset = () => {
  if (currentSalesType.value != -1) {
    currentTab.value = tab.value.active;
  }
  criteria.value.page = 1;
  criteria.value.size = 999;
  criteria.value.salesAccountUid = "";
  criteria.value.rebateAccountUid = "";
  criteria.value.sortField = "SalesAccountId";

  fetchData(1);
};

onMounted(async () => {
  fetchData(1);
});

const refresh = () => {
  fetchData(1);
};

const hasError = () => {
  hasErrorSetting.value = true;
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  criteria.value.salesAccountIds = null;
  criteria.value.status = currentTab.value;
  hasErrorSetting.value = false;

  try {
    const res = await RebateService.querySalesRebateSchemas(criteria.value);
    criteria.value = res.criteria;
    originalActiveData.value = res.data;
    data.value = res.data;

    if (currentTab.value == tab.value.pending) {
      data.value.forEach((items: any, index: number) => {
        const uniqueRebateAccountUids = new Set();
        const filteredItems = new Set();

        items.forEach((item: any) => {
          if (item.status === -1) {
            uniqueRebateAccountUids.add(item.rebateAccountUid);
            filteredItems.add(item);
          }
        });

        items.forEach((item: any) => {
          if (
            item.status === 0 &&
            !uniqueRebateAccountUids.has(item.rebateAccountUid)
          ) {
            uniqueRebateAccountUids.add(item.rebateAccountUid);
            filteredItems.add(item);
          }
        });
        data.value[index] = Array.from(filteredItems);
      });
    }

    if (currentSalesType.value != -1) {
      changeSalesType(currentSalesType.value);
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const changeSalesType = async (type: any) => {
  isLoading.value = true;
  currentSalesType.value = type;

  if (currentTab.value == tab.value.pending) {
    currentTab.value = tab.value.active;
    await fetchData(1);
  }

  data.value = originalActiveData.value.filter((innerArray) =>
    innerArray.some((item) => item.salesType === type)
  );
  isLoading.value = false;
};

const waitingApprove = () => {
  currentSalesType.value = -1;
  currentTab.value = tab.value.pending;
  reset();
};

const showAddNewModal = () => {
  AddSchamaRef.value.show();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: currentTab.value === tab.value.active },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
            (currentTab.value = tab.value.active), (currentSalesType.value = -1), fetchData(1)
          ))
        }, "ALL", 2)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesTypeOptions), (types, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "nav-item"
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: currentSalesType.value === types.value },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (changeSalesType(types.value))
          }, _toDisplayString(types.tab), 11, _hoisted_4)
        ]))
      }), 128)),
      _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("a", {
          class: "nav-link text-active-primary pb-4",
          "data-bs-toggle": "tab",
          href: "#",
          onClick: waitingApprove
        }, "Waiting Approve")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_input, {
              modelValue: criteria.value.salesAccountUid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.salesAccountUid) = $event)),
              placeholder: "Search Sales UID",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData(1)), ["enter"])),
              disabled: tab.value.pending === currentTab.value
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_input, {
              class: "ms-5",
              modelValue: criteria.value.rebateAccountUid,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.rebateAccountUid) = $event)),
              placeholder: "Search Target UID",
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (fetchData(1)), ["enter"])),
              disabled: tab.value.pending === currentTab.value
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_button, {
              class: "ms-5",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1))),
              disabled: tab.value.pending === currentTab.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Search")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "ms-5",
              onClick: reset,
              disabled: tab.value.pending === currentTab.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_button, {
              class: "ms-5",
              onClick: showAddNewModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Rule")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (data.value.length == 0 && isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(LoadingCentralBox)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (hasErrorSetting.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (items) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-6 mb-3",
            key: items
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(SalesRebateSchemaCard, {
                items: items,
                isLoading: isLoading.value,
                onRefresh: refresh,
                onHasError: hasError
              }, null, 8, ["items", "isLoading"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(AddSchama, {
      ref_key: "AddSchamaRef",
      ref: AddSchamaRef,
      onRefresh: refresh
    }, null, 512)
  ]))
}
}

})